export { MainContent } from "./main-content.vue";
